module.exports = __webpack_public_path__ + "static/img/blog8.2c7037d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/blog8.jpg
// module id = D4at
// module chunks = 0